var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUser2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93066 12.1494C5.74062 10.2895 10.2911 10.2895 13.0811 12.1494C14.3411 12.9894 15.031 14.1304 15.041 15.3604C15.0408 16.6001 14.3408 17.74 13.0811 18.5898C11.6811 19.5298 9.84096 20 8.00098 20C6.16098 20 4.3209 19.5298 2.9209 18.5898C1.66093 17.7498 0.960938 16.6099 0.960938 15.3799C0.960938 14.1499 1.66066 12.9994 2.93066 12.1494ZM8.00098 0C10.621 0 12.751 2.13 12.751 4.75C12.741 7.32 10.7309 9.40023 8.1709 9.49023H8.10059C8.04062 9.48029 7.96071 9.48025 7.88086 9.49023C5.26091 9.40018 3.25098 7.31996 3.25098 4.75C3.25098 2.13 5.38098 0 8.00098 0Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser2);
export default __webpack_public_path__ + "static/media/ic-user2.ab19ff0e7b37e235ea79947678e9fe6b.svg";
export { ForwardRef as ReactComponent };